<template>
    <div class="main">
        <!-- 头部搜索区域 -->
        <global-tag>
            <span slot="title">孕优对象</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="妻子姓名：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.personName"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label="联系方式：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.phone"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch" class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <!-- 搜索区域结束 -->
        <!-- 新增按钮区域 -->
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                     icon="el-icon-plus"
            class="openBtns"
                    size="medium"
                    @click="addServices('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                     icon="el-icon-download" class="button downOutBtns"
                    size="medium"
                    @click="createExcel"
                    >导出数据</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                 <label for="speechUpload" class="labelImportBtn inDwonBtns">
         
          <span> <i class="el-icon-upload2"></i>导入数据</span>
        </label>
                <el-button
                    type="warning"
                    icon="el-icon-sold-out" class="button modelDownds"
                    size="medium"
                    @click="downExcel"
                    >下载模板</el-button
                >
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox
                                            label="妻子姓名"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="身份证号"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="联系电话"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="妻子户籍地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="妻子人员类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="丈夫姓名"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="丈夫身份证号码"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="丈夫联系方式"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="备注"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="标准地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="点位坐标"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- 主页表格区域 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="300px"
                ref="multipleTable"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="60"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="妻子姓名"
                    min-width="120px"
                    align="center"
                    prop="wifeName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '妻子姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="身份证号"
                    min-width="160px"
                    align="center"
                    prop="wifeIdCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '身份证号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="联系电话"
                    min-width="120px"
                    align="center"
                    prop="wifePhone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="妻子户籍地址"
                    min-width="230px"
                    align="center"
                    prop="wifeOriginPlace"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '妻子户籍地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="妻子人员类型"
                    min-width="160px"
                    align="center"
                    prop="wifePersonnelType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '妻子人员类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.wifePersonnelType == 0"
                            >常住人口</span
                        >
                        <span v-if="scope.row.wifePersonnelType == 1"
                            >出租</span
                        >
                        <span v-if="scope.row.wifePersonnelType == 2"
                            >流动</span
                        >
                        <span v-if="scope.row.wifePersonnelType == 3"
                            >空房</span
                        >
                        <span v-if="scope.row.wifePersonnelType == 4"
                            >境外</span
                        >
                        <span v-if="scope.row.wifePersonnelType == 5"
                            >未落户</span
                        >
                        <span v-if="scope.row.wifePersonnelType == 6"
                            >商房</span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="丈夫姓名"
                    min-width="80px"
                    align="center"
                    prop="husbandName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '丈夫姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="丈夫身份证号码"
                    align="center"
                    min-width="180px"
                    prop="husbandIdCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '丈夫身份证号码'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="丈夫联系方式"
                    align="center"
                    min-width="150px"
                    prop="husbandPhone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '丈夫联系方式'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="备注"
                    align="center"
                    min-width="100px"
                    prop="remark"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '备注'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="标准地址"
                    align="center"
                    min-width="230px"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '标准地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="点位坐标"
                    align="center"
                    min-width="230px"
                    prop="longitude"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '点位坐标'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span
                            >{{ scope.row.longitude }},{{
                                scope.row.latitude
                            }}</span
                        >
                    </template>
                </el-table-column>

                <el-table-column
                    label="创建时间"
                    align="center"
                    min-width="180px"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑时间"
                    align="center"
                    min-width="180px"
                    prop="updateDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    min-width="100px"
                    prop="createPersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑人"
                    align="center"
                    min-width="100px"
                    prop="updatePersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    min-width="240px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div>
                            <span
                                @click="addServices('详情', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看</span
                            >
                            <span
                                @click="addServices('编辑', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >编辑</span
                            >
                            <span
                                @click="seeMap(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看地图定位</span
                            >
                            <!-- <span
                                @click="goSee(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >走访处理</span
                            > -->
                            <span
                                @click="deleteItem(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >删除</span
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
            @size-change="handletableDataSize"
            @current-change="handleTableDataChange"
            :page-sizes="[10, 20, 40, 100]"
            :page-size="pageOne.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageOne.total"
        ></el-pagination>
        <!-- 主页表格区域结束 -->
        <add-service
            v-if="serviceState"
            :openData="serviceInfo"
            @cancleService="cancleService"
        ></add-service>
        <map-info
            v-if="mapState"
            :openData="mapInfo"
            @cancleService="cancleService"
        ></map-info>
    </div>
</template>
<script>
import globalTag from "./components/globalTag"

import request from "@/utils/request.js"
import addService from "./components/addService"
import mapInfo from "@/components/mapInfo"
export default {
    name: "PregnantWomen",
    inject: ["reload"], //注入
    components: { globalTag, addService, mapInfo },
    data() {
        return {
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            tableData: [],
            queryInfo: { sex: "", personName: "", phone: "" },
            serviceState: false,
            serviceInfo: {},
            mapState: false,
            mapInfo: {},
            tempTableChekbox: [
                "序号",
                "妻子姓名",
                "身份证号",
                "联系电话",
                "妻子户籍地址",
                "妻子人员类型",
                "丈夫姓名",
                "丈夫身份证号码",
                "丈夫联系方式",
                "备注",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "妻子姓名",
                "身份证号",
                "联系电话",
                "妻子户籍地址",
                "妻子人员类型",
                "丈夫姓名",
                "丈夫身份证号码",
                "丈夫联系方式",
                "备注",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 新增\编辑\查看
        addServices(title, row) {
            this.serviceState = true

            this.serviceInfo = {}
            this.serviceInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
        },
        // 取消新增、编辑、查看
        cancleService(state) {
            this.serviceState = false
            this.mapState = false
            if (state == true) {
                this.getList()
            }
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 获取数据

        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 页面刷新
        reset() {
            this.reload()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                wifeName: this.queryInfo.personName,
                wifePhone: this.queryInfo.phone,
            }
            this.$http
                .request({
                    url: "/ypt/admin/optimalPeople/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/optimalPeople/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            // this.tableData = [];
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
            })
        },
        // 查看定位
        seeMap(row) {
            this.mapState = true
            this.mapInfo = {
                address: row.address,
                longitude: row.longitude,
                latitude: row.latitude,
                provinceId: row.provinceId,
                cityId: row.cityId,
                zoneId: row.zoneId,
                streetId: row.streetId,
                shequId: row.shequId,
                id: row.id,
                state: true,
            }
        },

        // 搜索
        querySearch() {
            this.getList()
        },
        // 下载模板
        async downExcel() {
            const res = await this.request2({
                url: "/ypt/admin/optimalPeople/info/downloadExcel",
                method: "POST",
                data: {
                    postName: "*",
                },
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "孕优对象.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        //导出excel
        async createExcel() {
            const res = await this.request2({
                url: "/ypt/admin/optimalPeople/info/downloadExcel",
                method: "POST",
                data: {},
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "孕优对象.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/optimalPeople/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.table_title {
    margin-top: 15px !important;
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 14px;
    padding: 4px 21px;
    color: #fff;
    line-height: 30px;
    display: inline-block;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>